import { useTranslation } from 'react-i18next';
import useClientsList from '@modules/clients/entities/client/query/useClientsList';
import { ClientsRoute } from '@modules/clients/presentation/routes';
import { useEffect } from 'react';
import { useLayoutStore } from '@modules/core/store';
import { InfoWidget } from '@components/v2/InfoWidget';
import { Flex } from '@huspy/briks-web';
import MainContentPageWrapper from '@components/v2/MainContentPageWrapper';
import ControlPanel from '@modules/clients/presentation/v2/pages/List/features/ControlPanel';
import ClientsTable from '@modules/clients/presentation/v2/pages/List//features/ClientsTable';
import AddClientSlido from '@modules/clients/presentation/v2/pages/List//features/AddClientSlido';
import usePersistUser from '@modules/core/hooks/usePersistUser';

const CLIENTS_PAGE_LIMIT = '7';

export const ClientsListPage = () => {
  const { t } = useTranslation();
  const { user } = usePersistUser();

  const q = ClientsRoute.useSearch();

  const {
    data, isLoading, isRefetching, error,
  } = useClientsList({ ...q, limit: CLIENTS_PAGE_LIMIT }, user?.brokerageId);

  const { setHeaderContent } = useLayoutStore();

  useEffect(() => {
    setHeaderContent(<AddClientSlido />);

    return () => {
      setHeaderContent(null);
    };
  }, [setHeaderContent]);

  return (
    <MainContentPageWrapper
      title={ t('clients.v2.title') }
      subtitle={ t('clients.v2.subtitle') }
      asideTitleContent={ (
        <Flex align='center' gap={ 3 }>
          <InfoWidget
            title={ t('clients.v2.totalCount') }
            isLoading={ isLoading }
            content={ data?.total_unfiltered_records }
          />
        </Flex>
      ) }
    >
      <Flex justify='space-between' pt='6' pb='10'>
        <ControlPanel />
      </Flex>

      <ClientsTable
        isLoading={ isLoading || isRefetching }
        data={ data }
        error={ !!error }
      />
    </MainContentPageWrapper>
  );
};
